<h2 mat-dialog-title class="dialog-title">Events am {{ formatDay(data.date) }}</h2>
<p class="dialog-subtitle">{{ formatDateOnly(data.date) }}</p>
<div class="dialog-subtitle-divider"></div>

<mat-dialog-content class="events-dialog-content">
  <div class="events-list" *ngIf="data.events.length > 0; else noEvents">
    <mat-card
      class="event-card"
      [style.border-color]="getTypeColor(event.type)"
      *ngFor="let event of data.events">
      <div class="event-main">
        <div class="event-title">{{ event.name }}</div>
        <div class="event-time">{{ formatShortDate(asDate(event.start)) }} {{ formatTime(asDate(event.start)) }} - {{ formatShortDate(asDate(event.end)) }} {{ formatTime(asDate(event.end)) }}</div>
      </div>
      <div class="event-actions">
        <div class="event-actions-divider" *ngIf="data.canEdit || data.canDelete"></div>
        <button *ngIf="data.canEdit" mat-icon-button color="primary" aria-label="Event bearbeiten" (click)="onEdit(event)">
          <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="data.canDelete" mat-icon-button color="warn" aria-label="Event löschen" (click)="onDelete(event)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </mat-card>
  </div>

  <ng-template #noEvents>
    <p class="empty-state">Keine Events für diesen Tag.</p>
  </ng-template>
</mat-dialog-content>

<div class="dialog-list-divider"></div>

<mat-dialog-actions align="end" class="dialog-actions" [class.single-action]="!data.canCreate">
  <button *ngIf="data.canCreate" mat-raised-button color="primary" class="dialog-btn dialog-btn-create" (click)="onCreate()">
    <mat-icon>add</mat-icon>
    <span class="dialog-btn-label">Create</span>
  </button>
  <button mat-stroked-button color="warn" class="dialog-btn dialog-btn-close" (click)="onClose()">
    <mat-icon>close</mat-icon>
    <span class="dialog-btn-label">Close</span>
  </button>
</mat-dialog-actions>
